import { render, staticRenderFns } from "./SkeletonSalesOrdersComponent.vue?vue&type=template&id=1a87533f&scoped=true&"
import script from "./SkeletonSalesOrdersComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonSalesOrdersComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonSalesOrdersComponent.vue?vue&type=style&index=0&id=1a87533f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87533f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
